import React from "react";
import { CreateCurrencyDto } from "../../../dtos/catalogs/currency/CreateCurrencyDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CustomerSettlementAnalyticsDetail } from "../../../components/Pages/Catalogs/CustomerSettlementAnalytics/CustomerSettlementAnalyticsDetail";
import CustomerSettlementAnalyticsList from "../../../components/Pages/Catalogs/CustomerSettlementAnalytics/CustomerSettlementAnalyticsList";
import { CustomerSettlementAnalyticsService } from "../../../services/catalogs/CustomerSettlementAnalyticsService";
import { NFLookupCustomerSettlementAnalytics } from "../../../components/Shared/NewForms/NFLookupCustomerSettlementAnalytics";
import { CreateCustomerSettlementAnalyticsDto } from "../../../dtos/catalogs/CustomerSettlementAnalytics/CreateCustomerSettlementAnalyticsDto";

export const CustomerSettlementAnalytics: IAppEntity = {
  entityType: "catalog",
  title: "CustomerSettlementAnalytics",
  pluralTitle: "CustomerSettlementAnalytics",
  apiUrl: "CustomerSettlementAnalytics",
  apiEnum: ReferenceTypes.CatalogCustomerSettlementAnalytic,
  getDetailViewComponent(model: any, modelUpdatedEvent: (model: any) => void): any {
    return React.createElement(CustomerSettlementAnalyticsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CustomerSettlementAnalyticsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCustomerSettlementAnalytics, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService() {
    return new CustomerSettlementAnalyticsService(this.apiUrl);
  },
  getEmptyModel(): CreateCustomerSettlementAnalyticsDto {
    return {
      name: "",
      createdDate: new Date(),
    };
  }
};
